import { LoanService } from '@/utils/service'
import { getCaller } from '@/utils/tools'

export const getQuotaInfo = () => {
  return new LoanService({
    url: '/loan/app/v4/quota/info',
    method: 'get'
  })
}
export const activatedQuota = () => {
  return new LoanService({
    url: '/loan/app/v4/tmp/quota/credit',
    method: 'post',
    data: {
      caller: getCaller()
    }
  })
}
